import { ObjectLiteral } from '@prophecy/interfaces/generic';
import queryString from 'query-string';

import { ShareDetails } from '../data/apis/types';

const SHARE_WINDOW_KEY = '__prophecy-share-token';
export const SHARE_TOKEN_KEY = 'share-token';

const windowStore = window as ObjectLiteral;

interface ShareToken {
  key: string;
  shareDetails?: ShareDetails['shareDetails'];
  hasDirectAccess?: boolean;
  loggedInUserId?: string;
  get: () => string | null;
  set: (value: string) => void;
  delete: () => void;
}

export const shareToken: ShareToken = {
  key: SHARE_TOKEN_KEY,
  get() {
    return windowStore[SHARE_WINDOW_KEY] as string;
  },
  set(value: string) {
    windowStore[SHARE_WINDOW_KEY] = value;
  },
  delete() {
    windowStore[SHARE_WINDOW_KEY] = null;
  }
};

export function addShareTokenQuery(url: string) {
  const token = shareToken.get();
  if (!token) return url;
  const tokenQuery = queryString.stringify({ [SHARE_TOKEN_KEY]: token });
  return url.includes('?') ? `${url}&${tokenQuery}` : `${url}?${tokenQuery}`;
}

export const isShareMode = () => {
  return Boolean(shareToken.get());
};
